import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "cinema__detail-operation" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 返回 ")
const _hoisted_3 = { class: "cinema__detail-operation-menu" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 更多 ")
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "cinema__detail-poster" }
const _hoisted_7 = { class: "cinema__detail-info" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "cinema__detail-title" }, " 选集 ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "cinema__detail-title" }, " 简介 ", -1)
const _hoisted_12 = { class: "cinema__detail-brief" }
const _hoisted_13 = {
  key: 2,
  class: "actor-list-wrapper"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "cinema__detail-title" }, " 演职人员 ", -1)
const _hoisted_15 = {
  key: 0,
  class: "actor-pagination"
}
const _hoisted_16 = { class: "pagination-page" }
const _hoisted_17 = { class: "profile-wrapper" }
const _hoisted_18 = ["onError", "alt", "title", "src"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "profile-wrapper" }
const _hoisted_22 = ["onError", "alt", "title", "src"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "cinema__detail-title" }
const _hoisted_26 = { class: "cinema__detail-origin" }

import { onMounted, onUnmounted, ref, PropType, computed } from 'vue'
import router from '@remote/router'
import { IconPageLeft } from '@xunlei/thunder-icon-vue'
import CinemaDetailEpisodes from './CinemaDetailEpisodes.vue'
import CinemaDetailRecommendList from './CinemaDetailRecommendList'
import fallback from '@shared/assets/img/cinema-fallback.png'
import { useScrollCollection } from '@shared/composable/cinema'
import { SECOND } from '@shared/constants/time'
import { 
  usePromisifyDialog,
} from '@shared/utils/dialog'
import { 
  openPopCinemaFeedback,
  openPopCinemaModify,
  toast,
} from '@remote/utils/dialog'

import SVGIcon from '@remote/components/SVGIcon.vue'
import { getNFORecommend as getNFORecommendApi, getDramas as getDramasApi, getNFOInfo } from '@remote/api/nfo'
import { formatLastTime } from '@remote/utils'
import { useToggle } from '@shared/composable/base'
import TheViewerVideo from '@remote/components/preview-album/TheViewerVideo.vue'
import {getCinemaInfo, getFileInfoToPreview} from '@remote/store/hezi-file'
import { 
  useCinemaStore, 
  deleteNFO,
  computedNFOName,
  computedNFOPlayProgress,
  computedNFOIsTV,
  computedNFOIsOther,
  computedNFOFileId,
  cinemaEventBus, 
  cinemaEventBusEvents,
} from '@remote/store/cinema'
import { 
  isHeziPCClient, 
  playVideo, 
  isNearBy, 
  HeziPCClientMessage, 
} from '@remote/utils/hezi-pc-client'
import { store } from '@remote/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  nfo: {
    type: Object as PropType<API_NFO.NFO>,
    required: true,
  },
  from: {
    type: String as PropType<Stat.CinemaFrom>,
    default: '',
  },
},
  emits: ['dialog-close'],
  setup(__props, { emit }) {

const props = __props




const { close } = usePromisifyDialog(emit)

const isMountedRef = ref(false)
const isImageErred = ref(false)
const dramaSeries = ref<API_NFO.Drama[]>([])
const recommendList = ref<API_NFO.NFO[]>([])
const actorListNodeRef = ref<HTMLDivElement | null>(null)
const actorListInnerNodeRef = ref<HTMLDivElement | null>(null)
const failedActorProfileSet = ref<Set<string>>(new Set())
const nfo = ref<API_NFO.NFO>(props.nfo)
const playInfo = ref(null)
const playing = ref(false)

const {
  isScrollLeftShow,
  isScrollRightShow,
  scrollLeft,
  scrollRight,
  pageIndex,
  pageTotal,
} = useScrollCollection(actorListNodeRef, actorListInnerNodeRef)
const { is: isMenuShow, toggle: toggleMenuShow } = useToggle({ defaultIs: false })
const cinemaStore = useCinemaStore()

const currentFileId = computed(() => computedNFOFileId(nfo.value))
const title = computed(() => {
  const name = computedNFOName(nfo.value)
  return nfo.value.scrape_result.season && nfo.value.scrape_result.season !== '0' ? `${name}·第${nfo.value.scrape_result.season}季` : name
})

const episodeInfo = computed(() => {
  const totalEP = Number(nfo.value.scrape_result?.episodes)
  const localEP = Number(nfo.value.scrape_result?.dramas?.length) || nfo.value.scrape_result.episode_nums
  if (totalEP > 0 && localEP > 0) {
    return `共${totalEP}集（已有${localEP}集）`
  }
  return ''
})

const totalTimeInChinese = computed(() => {
  if (nfo.value.video_info?.during) {
    const date = new Date(Number(nfo.value.video_info?.during) * SECOND)
    const hour = date.getUTCHours()
    const min = date.getUTCMinutes()
    if (hour >= 1 && min >= 1) return `${hour}小时${min}分钟`
    if (hour >= 1 && min <= 0) return `${hour}小时`
    if (hour <= 0) return `${min}分钟`
  }
  return ''
})

const info = computed(() => {
  return [
    nfo.value.scrape_result?.year ? `${nfo.value.scrape_result?.year}年` : '',
    totalTimeInChinese.value,
    (nfo.value?.scrape_result?.kind ?? []).slice(0, 3).join('、'),
    episodeInfo.value,
  ].filter(i => i !== '').join(' · ').trim()
})

const menu = computed(() => {
  const menu = [
    {
      text: '删除',
      onClick: () => deleteNFO(nfo.value, cinemaStore.deleteNFO, false, onClose),
      isShow: true,
    },
    {
      text: '修改信息',
      onClick: () => openPopCinemaModify({nfo:nfo.value}),
      isShow: nfo.value.scrape_result?.class !== 'other',
    },
    {
      text: '错误反馈',
      onClick: () => openPopCinemaFeedback({nfo:nfo.value}),
      isShow: nfo.value.scrape_result?.class !== 'other',
    },
  ]
  return menu
})

const progress = computed(() => computedNFOPlayProgress(nfo.value))

const imgURL = computed(() => {
  if (isImageErred.value) {
    return fallback
  }
  return nfo.value.scrape_result?.poster_horizontal || nfo.value.scrape_result?.poster_vertical || ''
})

const isTV = computed(() => computedNFOIsTV(nfo.value))
const isOther = computed(() => computedNFOIsOther(nfo.value))

onMounted(async () => {
  window.setTimeout(() => {
    isMountedRef.value = true
  }, 0)
  console.log('nfo', nfo.value)
  router.afterEach(onClose)
  getDramas(nfo.value)
  getNFORecommend(nfo.value, currentFileId.value)

  cinemaEventBus.addEventListener(cinemaEventBusEvents.modifyCinema, forceGetNFoInfo)
  HeziPCClientMessage.addEventListener('message', onHeziClientPlayend)
})

onUnmounted(() => {
  cinemaEventBus.removeEventListener(cinemaEventBusEvents.modifyCinema, forceGetNFoInfo)
  HeziPCClientMessage.removeEventListener('message', onHeziClientPlayend)
})

function onClose () {
  playInfo.value = null
  playing.value = false
  cinemaStore.refreshRecentNFOList()
  if (!isMountedRef.value) return
  isMountedRef.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}

async function getPlayInfo (fileId:string) {
  let promiseRet
  if (isOther.value) {
    promiseRet = getFileInfoToPreview({
      md5sum: fileId,
      path: nfo.value.video_info?.real_path || '',
      size: String(nfo.value.video_info?.file_size),
      hash: nfo.value.video_info?.hash || '',
    })
  } else {
    promiseRet = getCinemaInfo(fileId)
  }
  promiseRet.then(async res => {
    if (res && res.id === fileId) {
      if (isHeziPCClient()) {
        // pc客户端打开播放窗口
        let playUrl = res.web_content_link as string
        const ip = store.state.curDeviceRunner.params?.lan_ip
        let nearPlayUrl
        if (ip && res?.links) {
          console.log('link:', res?.links[`application/local-${ip}`])
          nearPlayUrl = res?.links[`application/local-${ip}`]?.url
          console.log('nearPlayUrl:', nearPlayUrl)
          if (nearPlayUrl) {
            const isNear = await isNearBy(ip)
            if (isNear) playUrl = nearPlayUrl
          }
        }
        playing.value = true
        return playVideo(playUrl, JSON.stringify({...res, name: title.value}))
      } else {
        playInfo.value = res
        playing.value = true
      }
    }
  })
}

async function getDramas (nfo:API_NFO.NFO) {
  if (!computedNFOIsTV(nfo)) return dramaSeries.value = []
  const dramaSeriesResult = await getDramasApi(nfo.scrape_result?.id as number, 200)
  if (dramaSeriesResult?.length) {
    console.log('dramaSeriesResult', dramaSeriesResult)
    dramaSeries.value = [...dramaSeriesResult]
  }
}

async function getNFORecommend (nfo:API_NFO.NFO, fileId) {
  const recommendResult = await getNFORecommendApi({id: nfo.scrape_result?.id, page_size: 30, file_id: fileId})
  console.log('recommendResult', recommendResult)
  if (recommendResult?.nfos && Array.isArray(recommendResult.nfos)) {
    recommendList.value = [...recommendResult.nfos]
  }
}

async function forceGetNFoInfo (fileId?:string) {
  const nfoInfo = await getNFOInfo(fileId || currentFileId.value)
  console.log('nfoInfo', nfoInfo)
  if (nfoInfo.nfos) {
    nfoInfo.nfos.last_record = Object.assign({}, nfoInfo.nfos.last_record, nfoInfo.last_record)
    nfo.value = nfoInfo.nfos
    await getDramas(nfoInfo.nfos)
    await getNFORecommend(nfoInfo.nfos, fileId || currentFileId.value)
  }
}

async function setViewNewCinemaDetail (fileId:string) {
  console.log('setViewNewCinemaDetail', fileId)
  if (fileId) await forceGetNFoInfo(fileId)
  playInfo.value = null
  playing.value = false
}

async function playNextEpisode (fileId:string) {
  const nfoInfo = await getNFOInfo(fileId || currentFileId.value)
  if (nfoInfo.nfos) {
    nfoInfo.nfos.last_record = Object.assign({}, nfoInfo.nfos.last_record, nfoInfo.last_record, {file_id: fileId})
    nfo.value = nfoInfo.nfos
  }
  getPlayInfo(fileId)
}

async function onPlayendAutoPlayNextEpisode (fileId:string) {
  const currentDramaFileId = fileId || currentFileId.value
  if (!isTV.value) return
  const dramaSeriesLength = dramaSeries.value.length
  const currentDramaIndex = dramaSeries.value.findIndex(drama => drama.file_id === currentDramaFileId)
  let nextDramaIndex = 0
  if (dramaSeriesLength > 1 && currentDramaIndex < dramaSeriesLength - 1) {
    nextDramaIndex = currentDramaIndex + 1
  }
  const nextDramaFileId = dramaSeries.value[nextDramaIndex].file_id
  playNextEpisode(nextDramaFileId)
}

async function onHeziClientPlayend (event:string, fileId: string) {
  if (event === 'PLAYEND' && fileId === currentFileId.value) {
    console.log('PLAYEND', fileId)
    onPlayendAutoPlayNextEpisode(fileId)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["cinema__detail-content custom-scrollbar", {'is-mounted': isMountedRef.value}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          onClick: onClose,
          class: "cinema__detail-operation-btn"
        }, [
          _createVNode(SVGIcon, {
            name: "back",
            width: "16px",
            height: "16px"
          }),
          _hoisted_2
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: "cinema__detail-operation-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleMenuShow)(true)))
          }, [
            _createVNode(SVGIcon, {
              name: "more",
              width: "16px",
              height: "16px"
            }),
            _hoisted_4
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "wrapper",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(toggleMenuShow)(false)))
          }, null, 512), [
            [_vShow, _unref(isMenuShow)]
          ]),
          _withDirectives(_createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item) => {
              return _withDirectives((_openBlock(), _createElementBlock("li", {
                key: item.text,
                onClick: ($event: any) => {_unref(toggleMenuShow)(false);item.onClick()}
              }, _toDisplayString(item.text), 9, _hoisted_5)), [
                [_vShow, item.isShow]
              ])
            }), 128))
          ], 512), [
            [_vShow, _unref(isMenuShow)]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TheViewerVideo, {
          class: "in-cinema__detail",
          style: {position: 'relative', width: '100%', height: '100%'},
          id: _unref(currentFileId),
          "preview-file-info": playInfo.value,
          "default-cover": _unref(imgURL),
          "video-duration": _unref(formatLastTime)(nfo.value.video_info.during),
          "auto-play": true,
          "auto-play-next": true,
          "default-video-progress": _unref(progress),
          "default-video-cur-time": _unref(formatLastTime)(Math.ceil(nfo.value.video_info.during * _unref(progress) / 100)),
          onPlayend: onPlayendAutoPlayNextEpisode
        }, null, 8, ["id", "preview-file-info", "default-cover", "video-duration", "default-video-progress", "default-video-cur-time"]),
        (!playInfo.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cinema__detail-poster-cover",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (getPlayInfo(_unref(currentFileId))))
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h2", null, _toDisplayString(_unref(title)), 1),
          (_unref(info))
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(info)), 1))
            : _createCommentVNode("", true)
        ]),
        (Number(dramaSeries.value?.length) > 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_10,
              _createVNode(CinemaDetailEpisodes, {
                dramas: dramaSeries.value,
                nfo: nfo.value,
                onView: playNextEpisode,
                "active-id": _unref(currentFileId),
                playing: !!playInfo.value || playing.value
              }, null, 8, ["dramas", "nfo", "active-id", "playing"])
            ], 64))
          : _createCommentVNode("", true),
        (nfo.value?.scrape_result?.biref)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_11,
              _createElementVNode("p", _hoisted_12, _toDisplayString(nfo.value?.scrape_result?.biref.trim()), 1)
            ], 64))
          : _createCommentVNode("", true),
        (Number(nfo.value.scrape_result?.actors?.length) > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("ul", {
                class: "actor-list hide-scrollbar",
                ref_key: "actorListNodeRef",
                ref: actorListNodeRef
              }, [
                (_unref(isScrollLeftShow) || _unref(isScrollRightShow))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["pagination-left", { disabled: !_unref(isScrollLeftShow) }]),
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(scrollLeft) && _unref(scrollLeft)(...args)))
                      }, [
                        _createVNode(_unref(IconPageLeft))
                      ], 2),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(pageIndex)) + "/" + _toDisplayString(_unref(pageTotal)), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["pagination-right", { disabled: !_unref(isScrollRightShow) }]),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(scrollRight) && _unref(scrollRight)(...args)))
                      }, [
                        _createVNode(_unref(IconPageLeft))
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "actor-list-inner",
                  ref_key: "actorListInnerNodeRef",
                  ref: actorListInnerNodeRef
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nfo.value.scrape_result?.directors, (actor, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `director-${index}`,
                      class: "actor",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(toast)('暂不支持查看详情信息')))
                    }, [
                      _createElementVNode("div", _hoisted_17, [
                        (actor.profile_path && !failedActorProfileSet.value.has(actor.name ?? ''))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              onError: ($event: any) => (failedActorProfileSet.value.add(actor.name ?? '')),
                              alt: actor.name,
                              title: actor.name,
                              src: actor.profile_path,
                              draggable: "false"
                            }, null, 40, _hoisted_18))
                          : (_openBlock(), _createBlock(SVGIcon, {
                              key: 1,
                              name: "profile",
                              width: "72px",
                              height: "72px"
                            }))
                      ]),
                      _createElementVNode("p", {
                        title: actor.name
                      }, _toDisplayString(actor.name), 9, _hoisted_19),
                      _createElementVNode("span", {
                        title: actor.chapter
                      }, "导演", 8, _hoisted_20)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nfo.value.scrape_result?.actors, (actor, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `actor-${index}`,
                      class: "actor",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(toast)('暂不支持查看详情信息')))
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        (actor.profile_path && !failedActorProfileSet.value.has(actor.name ?? ''))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              onError: ($event: any) => (failedActorProfileSet.value.add(actor.name ?? '')),
                              alt: actor.name,
                              title: actor.name,
                              src: actor.profile_path,
                              draggable: "false"
                            }, null, 40, _hoisted_22))
                          : (_openBlock(), _createBlock(SVGIcon, {
                              key: 1,
                              name: "profile",
                              width: "72px",
                              height: "72px"
                            }))
                      ]),
                      _createElementVNode("p", {
                        title: actor.name
                      }, _toDisplayString(actor.name), 9, _hoisted_23),
                      _createElementVNode("span", {
                        title: actor.chapter
                      }, " 演员 ", 8, _hoisted_24)
                    ]))
                  }), 128))
                ], 512)
              ], 512)
            ]))
          : _createCommentVNode("", true),
        (recommendList.value.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("h3", _hoisted_25, " 相关" + _toDisplayString(nfo.value.scrape_result?.class === 'tv' ? '电视剧' : '电影'), 1),
              _createVNode(_unref(CinemaDetailRecommendList), {
                nfos: recommendList.value,
                onView: setViewNewCinemaDetail
              }, null, 8, ["nfos"])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_26, " 原始信息：" + _toDisplayString(nfo.value.video_info?.real_path ?? '') + _toDisplayString(Number(nfo.value.scrape_result?.dramas?.length) > 1 ? ' 等' : ''), 1)
      ])
    ], 2)
  ]))
}
}

})